import { useTranslation } from "react-i18next";
import { Button } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

type Props = {
	handleAction: (shouldDelete?: boolean) => void;
	primaryActionLabel?: string;
	disablePrimaryButton?: boolean;
	loadingPrimaryButton?: boolean;
};

const DeleteFormActions = ({
	handleAction,
	primaryActionLabel,
	disablePrimaryButton,
	loadingPrimaryButton,
}: Props) => {
	const { t } = useTranslation();
	const labelCancel = t("common.cancel");
	const labelContinue = primaryActionLabel ?? t("common.continue");

	const theme = useAppTheme();
	return (
		<Box flexDirection="row" gap={16} paddingTop={16} justifyContent="flex-end">
			<Button
				textColor={theme.colors.onSurfaceVariant}
				onPress={() => handleAction(false)}
			>
				{labelCancel}
			</Button>
			<Button
				mode="contained"
				onPress={() => handleAction(true)}
				disabled={disablePrimaryButton}
				loading={loadingPrimaryButton}
			>
				{labelContinue}
			</Button>
		</Box>
	);
};

export default DeleteFormActions;
